export default __webpack_public_path__ + "static/media/ibbkidja003-color.92d8bac5.svg";